import { connect } from "react-redux";
// import PageTitle from 'components/common/PageTitle';
import React, { useRef, useState } from "react";
// import { rowData } from "util/data/reactTableData";
import { Button, ModalHeader, ModalBody } from "reactstrap";
import enhancer from "./enhancer/RoomEnhancer";
import Select from "react-select";
import { compose } from "redux";
import { getAllVenueStaffByServices } from "services/staffServices";
import { addRoom, editRoom } from "services/roomServices";
import NavigationActions from "redux/navigation/actions";
import { useEffect } from "react";
import Loader from "components/Loader";
import { getServiceByVenue } from "services/serviceServices";
import { Tag, X, Plus } from "react-feather";
import { VisibilityOff } from "@mui/icons-material";
import { Visibility } from "@mui/icons-material";
import PlaceHolderImage from "../../../assets/images/placeholder.png";

const { success, error } = NavigationActions;

const RoomModal = props => {
  const { isEdit, onClose } = props;
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    token,
    setFieldValue,
    isValid,
    setValues,
    handleSubmit,
    setFieldError,
    toggleRefresh,
    editData,
    user
  } = props;

  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [staffDataMap, setStaffDataMap] = useState({}); // Store staff data for each service
  const [togglePassword, setTogglePassword] = useState(false);

  useEffect(() => {
    if (isEdit && editData) {
      if (
        editData.service_data &&
        editData.staff_data &&
        !editData.service_staff_map_data
      ) {
        const serviceStaffMapData = editData.service_data.map(serviceId => ({
          service_id: serviceId,
          staff_data: editData.staff_data || []
        }));
        setValues({
          ...editData,
          service_staff_map_data:
            serviceStaffMapData.length > 0
              ? serviceStaffMapData
              : [{ service_id: "", staff_data: [] }]
        });
      } else {
        setValues({
          ...editData,
          service_staff_map_data:
            editData.service_staff_map_data &&
            editData.service_staff_map_data.length > 0
              ? editData.service_staff_map_data
              : [{ service_id: "", staff_data: [] }]
        });
      }
    } else {
      // Initialize with one empty service-staff mapping for new entries
      if (!values.service_staff_map_data) {
        setFieldValue("service_staff_map_data", [
          { service_id: "", staff_data: [] }
        ]);
      }
    }
  }, [editData, isEdit]);

  const getStaffDataForService = async serviceId => {
    if (!serviceId) return [];

    try {
      const res = await getAllVenueStaffByServices(token, [serviceId]);
      return (
        res.data?.map(val => ({
          value: val._id,
          label: val.name
        })) || []
      );
    } catch (err) {
      console.error("Error fetching staff data:", err);
      error(err.message || "Failed to fetch staff data");
      return [];
    }
  };

  const getServiceData = async () => {
    // Add validation for token and user
    if (!token || !user?._id) {
      console.error("Missing token or user data");
      error("Authentication required");
      return;
    }

    try {
      setLoading(true);

      // Pass user._id as venue_id parameter if required by the new API
      const res = await getServiceByVenue(token, user._id); // Added user._id parameter

      if (res && res.data) {
        let serviceArr = res.data?.map((val, i) => {
          return { value: val._id, label: val.name };
        });
        setServiceData(serviceArr);
      } else {
        console.warn("No service data received");
        setServiceData([]);
      }
    } catch (err) {
      console.error("Error fetching service data:", err);

      // Check if it's an authentication error
      if (err.response?.status === 401 || err.response?.status === 403) {
        error("Session expired. Please login again.");
        // Optional: Trigger logout or redirect to login
        // window.location.href = '/login';
      } else {
        error(err.message || "Failed to fetch service data");
      }
      setServiceData([]);
    } finally {
      setLoading(false);
    }
  };

  // Load staff data for each service when service changes
  const handleServiceChange = async (selectedService, index) => {
    const newServiceStaffMapData = [...(values.service_staff_map_data || [])];
    newServiceStaffMapData[index] = {
      ...newServiceStaffMapData[index],
      service_id: selectedService ? selectedService.value : "",
      staff_data: [] // Reset staff data when service changes
    };
    setFieldValue("service_staff_map_data", newServiceStaffMapData);

    // Load staff data for the selected service
    if (selectedService) {
      const staffData = await getStaffDataForService(selectedService.value);
      setStaffDataMap(prev => ({
        ...prev,
        [selectedService.value]: staffData
      }));
    }
  };

  const handleStaffChange = (selectedStaff, index) => {
    const newServiceStaffMapData = [...(values.service_staff_map_data || [])];
    newServiceStaffMapData[index] = {
      ...newServiceStaffMapData[index],
      staff_data: selectedStaff ? selectedStaff.map(staff => staff.value) : []
    };
    setFieldValue("service_staff_map_data", newServiceStaffMapData);
  };

  const addServiceStaffMapping = () => {
    const currentMappings = values.service_staff_map_data || [];
    setFieldValue("service_staff_map_data", [
      ...currentMappings,
      { service_id: "", staff_data: [] }
    ]);
  };

  const removeServiceStaffMapping = index => {
    const currentMappings = values.service_staff_map_data || [];
    if (currentMappings.length > 1) {
      const newMappings = currentMappings.filter((_, i) => i !== index);
      setFieldValue("service_staff_map_data", newMappings);
    }
  };

  // Modified useEffect to include proper error handling and dependencies
  useEffect(() => {
    // Only fetch service data if we have the required authentication
    if (token && user?._id) {
      getServiceData();
    } else {
      console.warn("Missing authentication data");
    }
  }, [token, user?._id]); // Added dependencies

  // Load staff data for existing services on component mount
  useEffect(() => {
    const loadExistingStaffData = async () => {
      if (values.service_staff_map_data) {
        for (const mapping of values.service_staff_map_data) {
          if (mapping.service_id) {
            const staffData = await getStaffDataForService(mapping.service_id);
            setStaffDataMap(prev => ({
              ...prev,
              [mapping.service_id]: staffData
            }));
          }
        }
      }
    };

    loadExistingStaffData();
  }, [values.service_staff_map_data?.length]);

  const getRandomPassword = () => {
    var length = 8,
      charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    setFieldValue("password", retVal);
  };

  useEffect(() => {
    !isEdit && getRandomPassword();
  }, []);

  // Debug logging to help troubleshoot
  useEffect(() => {
    console.log("Form values:", values);
    console.log("Form valid:", isFormValid());
    console.log("Original isValid:", isValid);
  }, [values]);

  // Custom validation for the new structure
  const isFormValid = () => {
    // Check basic required fields
    if (!values.name || !values.username || !values.password) {
      return false;
    }

    // Check service_staff_map_data
    if (
      !values.service_staff_map_data ||
      values.service_staff_map_data.length === 0
    ) {
      return false;
    }

    // Check each mapping has service_id and at least one staff
    for (const mapping of values.service_staff_map_data) {
      if (
        !mapping.service_id ||
        !mapping.staff_data ||
        mapping.staff_data.length === 0
      ) {
        return false;
      }
    }

    return true;
  };

  const RoomHandler = async e => {
    e.preventDefault();
    handleSubmit();
    if (isFormValid()) {
      const formData = new FormData();
      formData.append("file_image", values.file_image);
      if (values.image_galary && values.image_galary.length > 0) {
        values.image_galary.forEach((file, idx) => {
          formData.append("image_galary", file);
        });
      }
      formData.append("name", values.name);
      formData.append("username", values.username.toLowerCase());
      formData.append("password", values.password);

      // Send the new service_staff_map_data format
      formData.append(
        "service_staff_map_data",
        JSON.stringify(values.service_staff_map_data)
      );

      // For backward compatibility, also send the old format
      const allServiceIds =
        values.service_staff_map_data
          ?.map(item => item.service_id)
          .filter(Boolean) || [];
      const allStaffIds =
        values.service_staff_map_data?.flatMap(item => item.staff_data || []) ||
        [];
      formData.append("service_data", JSON.stringify(allServiceIds));
      formData.append("staff_data", JSON.stringify(allStaffIds));

      formData.append("venue_data", user._id);
      formData.append("status", values.status);
      setLoading(true);

      try {
        const res = isEdit
          ? await editRoom(token, values._id, formData)
          : await addRoom(token, formData);

        if (res.success) {
          success(res.message);
          toggleRefresh(true);
          onClose();
        } else {
          error(res.message);
        }
      } catch (err) {
        console.error("Room operation error:", err);
        error(err.message || "Operation failed");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleImageChange = e => {
    if (e.target.files.length !== 1) {
      return;
    }
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!allowedTypes.includes(file.type)) {
      setFieldError(e.target.name, "Only .jpg, .jpeg, .png files are allowed.");
      e.target.value = "";
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setFieldError(e.target.name, "File size should be less than 2MB.");
      e.target.value = "";
      return;
    }

    setFieldValue(e.target.name, file);
    fileInputRef.current.value = "";
  };

  const handleGalleryChange = e => {
    const files = Array.from(e.target.files);
    const allowedTypes = [
      "image/jpg",
      "image/jpeg",
      "image/png",
      "image/svg+xml",
      "image/svg",
      "image/gif"
    ];

    for (let file of files) {
      if (!allowedTypes.includes(file.type)) {
        setFieldError(
          "image_galary",
          "Only JPG, JPEG, PNG, SVG and GIF files are allowed."
        );
        e.target.value = "";
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setFieldError("image_galary", "Each file should be less than 2MB.");
        e.target.value = "";
        return;
      }
    }

    setFieldError("image_galary", "");

    const existingFiles = values.image_galary || [];
    const allFiles = [
      ...existingFiles,
      ...files.filter(
        newFile =>
          !existingFiles.some(
            f =>
              f.name === newFile.name &&
              f.size === newFile.size &&
              f.type === newFile.type
          )
      )
    ];
    setFieldValue("image_galary", allFiles);
    e.target.value = "";
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  // Early return if missing authentication
  if (!token || !user) {
    return (
      <div>
        <ModalHeader toggle={() => onClose()}>
          Authentication Required
        </ModalHeader>
        <ModalBody>
          <p>Please login to continue.</p>
          <Button onClick={() => onClose()} className="btn btn-secondary">
            Close
          </Button>
        </ModalBody>
      </div>
    );
  }

  return (
    <>
      <ModalHeader toggle={() => onClose()}>
        {isEdit ? "Edit" : "Add"} Room
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-group">
            <label>
              Name <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="name"
              onChange={handleChange}
              value={values.name}
              onBlur={handleBlur}
              placeholder="Room Name"
            />
            <Error field="name" />
          </div>
          <div className="form-group">
            <label>
              Username <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="username"
              onChange={handleChange}
              value={values.username}
              onBlur={handleBlur}
              placeholder="Username"
              disabled={isEdit ? true : false}
            />
            <Error field="username" />
          </div>
          <div className="form-group">
            <div className="row align-items-center">
              <div className="col">
                <label>
                  Password <span className="red">*</span>
                </label>
                <div className="input-group mb-3">
                  <input
                    type={togglePassword ? "text" : "password"}
                    className="form-control react-form-input"
                    id="password"
                    onChange={handleChange}
                    value={values.password}
                    onBlur={handleBlur}
                    placeholder="Room password"
                  />
                  <div className="input-group-append">
                    {togglePassword ? (
                      <VisibilityOff onClick={() => setTogglePassword(false)} />
                    ) : (
                      <Visibility onClick={() => setTogglePassword(true)} />
                    )}
                  </div>
                </div>
                <Error field="password" />
              </div>
              <div className="col-auto">
                <button
                  className="generate_btn"
                  onClick={e => {
                    e.preventDefault();
                    getRandomPassword();
                  }}
                  title="Generate New Password"
                >
                  <Tag />
                </button>
              </div>
            </div>
          </div>

          {/* Service-Staff Mapping Fields */}
          <div className="form-group">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label>
                Services & Staff <span className="red">*</span>
              </label>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={addServiceStaffMapping}
                title="Add Service-Staff Mapping"
              >
                <Plus size={16} />
              </button>
            </div>

            {(values.service_staff_map_data || []).map((mapping, index) => (
              <div key={index} className="border p-3 mb-3 rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">Service-Staff Mapping {index + 1}</h6>
                  {(values.service_staff_map_data || []).length > 1 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => removeServiceStaffMapping(index)}
                      title="Remove Mapping"
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>

                <div className="form-group mb-2">
                  <label className="small">Service</label>
                  <Select
                    value={serviceData.find(
                      service => service.value === mapping.service_id
                    )}
                    name={`service_staff_map_data[${index}].service_id`}
                    options={serviceData}
                    className="basic-single-select w-100"
                    classNamePrefix="select"
                    placeholder="Select Service"
                    onChange={selected => handleServiceChange(selected, index)}
                  />
                </div>

                <div className="form-group mb-0">
                  <label className="small">Staff</label>
                  <Select
                    value={(
                      staffDataMap[mapping.service_id] || []
                    ).filter(staff =>
                      (mapping.staff_data || []).includes(staff.value)
                    )}
                    isMulti
                    name={`service_staff_map_data[${index}].staff_data`}
                    options={staffDataMap[mapping.service_id] || []}
                    className="basic-multi-select w-100"
                    classNamePrefix="select"
                    placeholder="Select Staff"
                    isDisabled={!mapping.service_id}
                    onChange={selected => handleStaffChange(selected, index)}
                  />
                </div>
              </div>
            ))}
            <Error field="service_staff_map_data" />
          </div>

          <div className="form-group">
            <label>Image</label>
            <br />
            <input
              ref={fileInputRef}
              type="file"
              id="file_image"
              name="file_image"
              className="form-control react-form-input"
              accept="image/*"
              onChange={handleImageChange}
              onBlur={handleBlur}
            />
            <Error field="file_image" />

            {values?.file_image && (
              <>
                <br />
                <img
                  src={
                    values?.file_image instanceof Blob
                      ? URL.createObjectURL(values?.file_image)
                      : `${process.env.REACT_APP_UPLOAD_DIR}${values?.file_image}`
                  }
                  className="profile-img"
                  alt="no"
                  width={100}
                  onError={e => {
                    e.target.src = PlaceHolderImage;
                  }}
                />
                <br />
              </>
            )}
          </div>
          <div className="form-group">
            <label>Gallery Images</label>
            <br />
            <input
              type="file"
              id="image_galary"
              name="image_galary"
              className="form-control react-form-input mb-2"
              accept="image/*"
              multiple
              onChange={handleGalleryChange}
              onBlur={handleBlur}
            />
            <Error field="image_galary" />
            {values?.image_galary && values.image_galary.length > 0 && (
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  flexWrap: "wrap",
                  marginTop: 16
                }}
              >
                {values.image_galary.map((file, idx) => (
                  <div
                    key={idx}
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={
                        file instanceof Blob
                          ? URL.createObjectURL(file)
                          : `${process.env.REACT_APP_UPLOAD_DIR}${file}`
                      }
                      alt="gallery"
                      width={60}
                      height={60}
                      onError={e => {
                        e.target.src = PlaceHolderImage;
                      }}
                      style={{ objectFit: "cover", borderRadius: 4 }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        background: "#d00",
                        borderRadius: "50%",
                        cursor: "pointer",
                        padding: 3,
                        paddingTop: 0,
                        paddingBottom: 0
                      }}
                      title="Remove"
                      onClick={() => {
                        const newFiles = values.image_galary.filter(
                          (_, i) => i !== idx
                        );
                        setFieldValue("image_galary", newFiles);
                      }}
                    >
                      <X size={16} color="white" />
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="form-group">
            <label>
              Status <span className="red">*</span>
            </label>
            <select
              className="detail-input-select custom-select"
              value={values?.status}
              name="status"
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <option value={true}>Active</option>
              <option value={false}>Deactive</option>
            </select>
            <Error field="status" />
          </div>
          <div className="row">
            <div className="col-5 offset-2 offset-sm-4 col-sm-4">
              <Button
                onClick={e => RoomHandler(e)}
                type="submit"
                className="btn form-button modaladdbutton"
                disabled={!isFormValid()}
              >
                {isEdit ? "Update" : "Add"}
              </Button>
            </div>
            <div className="col-5 col-sm-4">
              <Button
                onClick={() => {
                  onClose();
                }}
                className="btn form-button modalcancelbutton"
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </ModalBody>
      {loading && <Loader />}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  enhancer,
  connect(mapStateToProps, { success, error })
)(RoomModal);
